import {create} from 'zustand';
import {persist} from 'zustand/middleware';

interface GuidesListViewState {
  view: 'grid' | 'table';
  updateView: (view: 'grid' | 'table') => void;
}

const key = '@blesk/guide-list-view';

export const guidesListViewStore = create(
  persist<GuidesListViewState>(
    (set) => ({
      view: 'grid',
      updateView: (view: GuidesListViewState['view']) => set({view}),
    }),
    {name: key},
  ),
);
